import { BaseService } from "@usercentrics/cmp-browser-sdk/dist/src/services/SettingsV2/interfaces";
import { BaseCategoryData } from "@usercentrics/cmp-browser-sdk/dist/src/services/SettingsV2/Data/interfaces";
import { CategoryLabels } from "@usercentrics/cmp-browser-sdk/dist/src/services/SettingsV2/Labels/interfaces";

export interface CmpCategorySetting extends BaseCategoryData, CategoryLabels {
  hasConsent: boolean;
  services: ExpandedCmpService[];
}

export interface ExpandedCmpService extends BaseService {
  oldConsent: boolean;
}

export interface CmpTexts {
  headline: string;
  descriptionBanner: string;
  descriptionPreferences: string;
  accept: string;
  acceptAll: string;
  deny: string;
  denyAll: string;
  save: string;
  learnMore: string;
  showLess: string;
  policyLink: string;
  imprintLink: string;
  [key: string]: string;
}

export interface CmpConsentDecisionToDomain {
  service: string;
  consent: boolean;
}

export enum ConsentLevel {
  ACCEPT_ALL = 1,
  SHOW_CATEGORIES,
  SHOW_SERVICES
}

export enum UsercentricsServiceId {
  HOTJAR_SERVICE_ID = "UfXw5BeKk",
  GOOGLE_ANALYTICS_CUSTOMIZED_SERVICE_ID = "fVL3U9AAU",
  GOOGLE_ANALYTICS_DEFAULT_SERVICE_ID = "HkocEodjb7",
  GOOGLE_OPTIMIZED_CUSTOMIZED_SERVICE_ID = "bQGO9G327",
  GOOGLE_OPTIMIZED_DEFAULT_SERVICE_ID = "gkEBFID-V",
  GOOGLE_CRASHLYTICS_CUSTOMIZED_SERVICE_ID = "not customized",
  GOOGLE_CRASHLYTICS_DEFAULT_SERVICE_ID = "8K4QDDTlf",
  GOOGLE_FIREBASE_CUSTOMIZED_SERVICE_ID = "s5tzka37q",
  GOOGLE_FIREBASE_DEFAULT_SERVICE_ID = "uNl9XGnZC",
  GOOGLE_RTBHOUSE_CUSTOMIZED_SERVICE_ID = "FWjDm8YKu",
  GOOGLE_RTBHOUSE_DEFAULT_SERVICE_ID = "B1Ayg5Es_s-X",
  TIKTOK_SERVICE_ID = "puPrn0Ul1",
  META_ADS_SERVICE_ID = "ep9Ae7Oxz",
  PINTEREST_SERVICE_ID = "0zz47BNml",
  SNAPCHAT_SERVICE_ID = "n_1Yfh5LF"
}
